import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/staff/schedules/company-schedule";

export default {
  getListOfCompanySchedule(from = '', to = '', type= '', scope="all", departmentIds = '') {
    let url = `${resource}?from=${from}&to=${to}&type=${type}&scope=${scope}`
    if (departmentIds) {
      const deptStr = Array.isArray(departmentIds) ? departmentIds.join(',') : departmentIds
      if (deptStr) {
        url += `&department-ids=${deptStr}`
      }
    }
    return Repository.get(url)
  }
};
